
interface Config {
    environment: 'development'|'staging'|'production';
    app: {
        version: string;
        name: string;
    };
    auth0: {
        domain: string;
        clientId: string;
        audience: string;
    };
    api: {
        newBaseUrl: string;
        newBackendUrl: string;
        apiKey: string;
    };
}

export const config = {
    environment: process.env.REACT_APP_ENV,
    app: {
        version: process.env.REACT_APP_VERSION,
        name: process.env.REACT_APP_NAME,
    },
    auth0: {
        domain: process.env.REACT_APP_AUTH0_DOMAIN,
        clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    },
    api: {
        newBaseUrl: process.env.REACT_APP_API_NEW_URL,
        newBackendUrl: process.env.REACT_APP_API_NEW_BACKEND_URL,
        apiKey: process.env.REACT_APP_API_KEY,
    },
} as Config;

// Public host of the shared end-user booking app. Production serves
// app.kolula.com; every non-production environment (integration / staging /
// development) serves the develop subdomain — matching the Amplify branch
// domains (main → app.kolula.com, develop → develop.app.kolula.com).
export const END_USER_APP_HOST =
    config.environment === 'production'
        ? 'app.kolula.com'
        : 'develop.app.kolula.com';
